module.exports = __webpack_public_path__ + "img/SPASCER.9917ef75.png";